// Coordinates use the visual viewport, including the space left by a mobile keyboard.
export function tourLayout(viewport, target, cardHeight) {
  const gap = 12;
  const width = Math.min(360, Math.max(0, viewport.width - gap * 2));
  const height = Math.min(cardHeight, Math.max(0, viewport.height - gap * 2));
  const start = viewport.top + gap;
  const end = viewport.top + viewport.height - gap;
  let top = start + (end - start - height) / 2;
  if (target) {
    const below = end - (target.top + target.height + gap);
    const above = target.top - gap - start;
    top = below >= height ? target.top + target.height + gap
      : above >= height ? target.top - gap - height
      : below >= above ? end - height : start;
  }
  return {
    top: Math.max(start, Math.min(top, end - height)),
    left: viewport.left + (viewport.width - width) / 2,
    width,
    maxHeight: Math.max(0, viewport.height - gap * 2),
  };
}
